import React, { useState, useMemo, useEffect } from "react";
import Switch from "../../switch/index";
import DropFile from "../../drop-file";
import WarningMessage from "../../../components/WarningMessage";
import ProgressBar from "@ramonak/react-progress-bar";
import { REG_EMAIL } from "../../../constants";
import { contactUsAndFiles } from "../../../api/public";
import "./style.css";

/* eslint import/no-webpack-loader-syntax: off */
import SvgSuccess from "-!svg-react-loader!../../../icons/success.svg";

const ERROR_FIELD = {
  default: "This field is required",
  email:
    "The email address entered is invalid, please check the formatting (e.g. email@domain.com).",
};
const MESSAGE_SUCCESS =
  "Thank you for your message, our team will get back to you shortly.";
const defaultValid = (val) => (val.trim().length ? false : ERROR_FIELD.default);
const validFields = {
  firstName: defaultValid,
  lastName: defaultValid,
  email: (val) => {
    if (val.trim().length === 0) return ERROR_FIELD.default;
    else if (val.match(REG_EMAIL) === null) return ERROR_FIELD.email;
    return false;
  },
};
export default function SendUsMessages({ calculatorValues }) {
  const [loading, setLoading] = useState(false);
  const [completed, setCompleted] = useState(0);

  const [isSendForm, setIsSendForm] = useState(false);

  const [fields, setFields] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setFields({
        ...fields,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
      });
    }
  }, []);

  useEffect(() => {
    setFields((prevFields) => ({
      ...prevFields,
      message:
        calculatorValues &&
        calculatorValues.height &&
        calculatorValues.width &&
        calculatorValues.totalPrice
          ? `Hello, I am interested in Canvas Stretching sized at ${calculatorValues.height} x ${calculatorValues.width} at $${calculatorValues.totalPrice}.`
          : fields.message,
    }));
  }, [calculatorValues]);

  const [errorFields, setErrorFields] = useState({
    firstName: false,
    lastName: false,
    email: false,
  });

  const setValue = ({ target }) =>
    setFields({
      ...fields,
      [target.name]: target.value,
    });

  const [files, setFiles] = useState([]);

  const sizeFiles = useMemo(() => {
    let size = 0;
    files.forEach((file) => (size = size + file.size));
    return size;
  }, [files]);

  const [uploadFile, setUploadFile] = useState(false);

  const changeSwitch = (value) => setUploadFile(value);

  const submitForm = (e) => {
    e.preventDefault();
    setIsSendForm(false);
    const validationFields = Object.keys(fields)
      .filter((key) => key !== "message")
      .filter((key) => {
        const valid = validFields[key](fields[key]);
        errorFields[key] = valid;
        return valid;
      });
    setErrorFields({ ...errorFields });
    if (validationFields.length === 0) {
      sendForm();
    }
  };

  const resetForm = () => {
    setIsSendForm(true);
    setFields({ ...fields, message: "" });
    setLoading(false);
    setFiles([]);
  };

  const sendForm = async () => {
    setLoading(true);
    setIsSendForm(false);

    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    Object.keys(fields).forEach((key) => formData.append(key, fields[key]));

    try {
      await contactUsAndFiles(formData, (val) => {
        const percent = Math.ceil((val / sizeFiles) * 100);
        setCompleted(percent > 100 ? 100 : percent);

        if (sizeFiles - val <= 0) {
          setIsSendForm(true);
          resetForm(true);
        }
      });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="send-us-message" id="send-us-message">
      {loading ? <div className="send-us-message__loading"></div> : null}
      <h4 className="send-us-message__title">Send us a message</h4>
      <form action="/" name="send-us-message" onSubmit={submitForm}>
        <div className="send-us-message__row-2 send-us-message__row send-us-message__row--md">
          <label
            htmlFor="first_name"
            id="firstName"
            className="send-us-message__field"
          >
            <input
              type="text"
              placeholder="First name*"
              name="firstName"
              onChange={setValue}
              value={fields.firstName}
            />
            {errorFields.firstName ? (
              <span className="send-us-message__filed-error">
                {errorFields.firstName}
              </span>
            ) : null}
          </label>
          <label
            htmlFor="last_name"
            id="lastName"
            className="send-us-message__field"
          >
            <input
              type="text"
              placeholder="Last name*"
              name="lastName"
              onChange={setValue}
              value={fields.lastName}
            />
            {errorFields.lastName ? (
              <span className="send-us-message__filed-error">
                {errorFields.lastName}
              </span>
            ) : null}
          </label>
        </div>
        <div className="send-us-message__row send-us-message__row--md">
          <label htmlFor="email" id="email" className="send-us-message__field">
            <input
              type="text"
              placeholder="Email*"
              name="email"
              onChange={setValue}
              value={fields.email}
            />
            {errorFields.email ? (
              <span className="send-us-message__filed-error">
                {errorFields.email}
              </span>
            ) : null}
          </label>
        </div>
        <div className="send-us-message__row send-us-message__row--md">
          <label
            htmlFor="message"
            id="message"
            className="send-us-message__field"
          >
            <textarea
              value={fields.message}
              onChange={setValue}
              name="message"
              id="message"
              className="textarea medium"
              placeholder="Your message"
              aria-invalid="false"
              rows="10"
              cols="50"
            ></textarea>
          </label>
        </div>
        <div className="send-us-message__row send-us-message__row--sm">
          <div className="send-us-message__files">
            <Switch checked={uploadFile} onSwitch={changeSwitch} />
            <span className="send-us-message__subtitle ">
              Would you like to send us any files?
            </span>
          </div>
          <DropFile
            name="send-us-message"
            show={uploadFile}
            files={files}
            setFiles={setFiles}
            classes={"send-us-message__drop-file"}
          />
          {loading ? (
            <ProgressBar
              transitionDuration={"0.1s"}
              completed={completed}
              maxCompleted={100}
              className="send-us-message__progress-bar"
            />
          ) : null}
        </div>
        <div className="send-us-message__success">
          {isSendForm ? (
            <WarningMessage message={MESSAGE_SUCCESS} success={true} />
          ) : null}
        </div>
        <button className="banner__btn" type="submit">
          Send
        </button>
      </form>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/new-components/form/send-us-message/index.js